export const NAME = 'campaignManagement-contactReleasing';

export const processes = {
	MANUAL_ASSIGN: 'MANUAL_ASSIGN',
	AUTOMATIC_ASSIGN: 'AUTOMATIC_ASSIGN',
	CONTACT_RELEASE: 'CONTACT_RELEASE',
	PRINT_MODE: 'PRINT_MODE',
};

export const progressType = {
	ASSIGN: 'ASSIGN',
	RELEASE: 'RELEASE',
	PRINT: 'PRINT',
};

export const subProcesses = {
	NO_PRINT: 'NO_PRINT',
	ANONYMOUS: 'ANONYMOUS',
	NAMED: 'NAMED',
	ZIP_CODE: 'ZIP_CODE',
	PORTFOLIO: 'PORTFOLIO',
};

export const automaticAssignSubProcesses = {
	ZIP_CODE: 'ZIP_CODE',
	PORTFOLIO: 'PORTFOLIO',
};

export const printModeSubProcesses = {
	NO_PRINT: 'NO_PRINT',
	ANONYMOUS: 'ANONYMOUS',
	NAMED: 'NAMED',
};

export const dialogs = {
	CONTACT_PROCESSING_ERROR: `${NAME}/CONTACT_PROCESSING_ERROR`,
	NO_SELLER_SELECTED: `${NAME}/NO_SELLER_SELECTED`,
	NO_CONTACT_SELECTED: `${NAME}/NO_CONTACT_SELECTED`,
	NO_CONTACTS_AVAILABLE: `${NAME}/NO_CONTACTS_AVAILABLE`,
	NO_PROCESS_SELECTED: `${NAME}/NO_PROCESS_SELECTED`,
};
